import { render, staticRenderFns } from "./AnalisiRisultati.vue?vue&type=template&id=268f828a&"
import script from "./AnalisiRisultati.vue?vue&type=script&lang=js&"
export * from "./AnalisiRisultati.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports